export default __webpack_public_path__ + "static/media/instant-rebate-ico.4f55c577.svg";